import React from 'react';
import { Outlet } from 'react-router-dom';

import { View } from 'dashboard/components/View';
import AccordillonMenu from 'dashboard/containers/AccordillonMenu';

import { ARCHIVED_ROUTE, LIVE_ROUTE } from './routes';

interface ContentSettingsProps {
  contentId: string;
}
export const SegmentsLayout = ({ contentId }: ContentSettingsProps) => {
  return (
    <View titleLvl2="Segments" subheader={<AccordillonMenu pages={[LIVE_ROUTE, ARCHIVED_ROUTE]} />}>
      <Outlet context={{ contentId }} />
    </View>
  );
};

export default SegmentsLayout;
